<template>
  <div id="app">
    <el-container v-if="$route.meta.keepAlive">
      <el-header>
        <headerNav></headerNav>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <leftNav :style="leftMenu"></leftNav>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import headerNav from '@/common/nav/headerNav.vue'
  import leftNav from '@/common/nav/leftNav.vue'
  export default {
    name: 'App',
    data() {
      return {
        demo: '',
        leftMenu: {
          width: '200px',
          height: ''
        }
      }
    },
    components: {
      headerNav: headerNav,
      leftNav: leftNav
    },
    created() {
      this.h()
    },
    methods: {
      h() {
        this.demo = `${document.documentElement.clientHeight-60}` + 'px';
        this.leftMenu.height = this.demo;
        setTimeout(() => {
          this.h()
        }, 10);
      },
    }
  }

</script>
<style lang="scss">
  html,
  body {
    margin: 0;
    padding: 0;

    #app {
      width: 100%;
      height: 100%;
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;

      .el-container {
        width: 100%;
        min-width: 1516px;
        height: 100%;

        .el-header {
          background: #0086C2;
          // background: #1F8BF4;
        }

        .el-container {
          width: 100%;
          height: 100%;

          .el-aside {
            background: #545c64;
          }

          .el-main {
            padding: 0;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue